import { useEffect } from 'react';

/**
 * Runs an effect exactly once on mount, with optional cleanup on unmount.
 *
 * Use this instead of `useEffect(..., [])` to make mount-only intent explicit.
 * For effects that depend on changing values, use `useEffect` directly.
 */
export function useMountEffect(effect: () => void | (() => void)) {
  // oxlint-disable-next-line react/exhaustive-deps
  useEffect(effect, []);
}
